<div id="ht">
    <div id="main-cnt">

        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content" *ngIf="contract">
                        <h6 class="text-center"> Proroga Contratto</h6>
                        <ion-input disabled="true" placeholder="Intestatario" class="text-input"
                                   type="text" [value]="clientName"
                                   [ngModel]="clientName"></ion-input>

                        <ion-input disabled="true" placeholder="Commerciale" class="text-input"
                                   type="text"
                                   value="{{contract.commercial?.name |titlecase}} {{contract.commercial?.lastname |titlecase}}"></ion-input>

                        <ion-input placeholder="Data fine" class="text-input"
                                   type="date" disabled [value]="contract.endDate"></ion-input>
                        <ion-select [(ngModel)]="years" (ionChange)="calaculatEndDate()" placeholder="Anni di proroga">
                            <ion-select-option *ngFor="let x of counter(20) ;let i = index" [value]="i">{{i}}
                            </ion-select-option>

                        </ion-select>
                        <ion-input *ngIf="years !== 0" placeholder="Data fine" class="text-input"
                                   type="date" disabled [value]="dateValue"></ion-input>


                        <ion-input placeholder="Importo" class="text-input"
                                   type="number" [(ngModel)]="importo" [max]="max"></ion-input>

                        <br>
                        <ion-spinner *ngIf="loading"></ion-spinner>
                        <button expand="block" type="submit" (click)="salva()" *ngIf="!loading"
                                class="button glass-blurred-background drop-shadow padding">Salva
                        </button>

                    </div>
                </div>
            </div>
        </ion-content>
    </div>
</div>
